import Button from './Button'
import { ButtonProps } from './types'

export function ButtonTransparent({ children, className, ...rest }: ButtonProps): React.ReactElement {
  return (
    <Button
      className={`bg-transparent border-2 border-solid border-white text-white hover:bg-purple-dark hover:text-white ${className}`}
      {...rest}
    >
      {children}
    </Button>
  )
}
